module.exports = "/_next/static/images/217fdd50f1ddc6acb1d6858b58438549-roxinho-details-metalico-xs@2x.jpg";